module.exports = __webpack_public_path__ + "static/media/HCMM445.dace7229.jpg";